import { enableScroll, disableScroll } from './tech/tech.js';
import * as  formsOld from './forms.js';
/** New PopUp DIALOG */
const mod = {
	dialog: () => {
		const btnOpen = document.querySelectorAll('[popovertarget]');
		const btnClose = document.querySelectorAll('._dialog__close');

		const openPopup = (e) => {
			e.preventDefault();
			const id = e.target.getAttribute('popovertarget');
			const dialog = document.getElementById(id);
			dialog.showModal();
			disableScroll();

			let blockHeading;
			const parent = e.target.parentElement;
			if (parent) {
				const blockTitle = parent.querySelector('h2');
				blockHeading = blockTitle ? blockTitle.textContent : '';
			}

			const buttonTitle = e.target.textContent;
			let formTitle;
			if (dialog.querySelector('._form__title')) {
				formTitle = `Відкрився попап - ${dialog.querySelector('._form__title').textContent}`;
			}
			formsOld.infoForm(dialog, `/ клікнули по кнопці - ${buttonTitle}. В блоці - ${blockHeading}. ${formTitle} /`);

		}
		const closePopup = (e) => {
			e.preventDefault();
			//console.log('close');
			const id = e.target.closest('dialog').getAttribute('id');
			const dialog = document.getElementById(id);
			dialog.close();
			dialog.classList.remove('_open');
			//console.log(dialog);

			let video = document.querySelector('#youtube-modal');
			if (video) {
				video.src = video.src;
			}
			enableScroll();
		}
		if (btnOpen.length > 0) {
			btnOpen.forEach(btn => {
				btn.addEventListener('click', openPopup);
			});
		}
		if (btnClose.length > 0) {
			btnClose.forEach(btn => {
				btn.addEventListener('click', closePopup);
			});
		}
	}
}

export const dialog = mod.dialog;